// models/metrics/metasearchMetrics/trivago-meta/trivagoMetaMetrics.js

// connectivity
import MetricUnavailabilityTrivago from "models/metrics/metasearchMetrics/trivago-meta/connectivity/MetricUnavailability";

// conversion
import MetricBookingcountTrivago from "models/metrics/metasearchMetrics/trivago-meta/conversion/MetricBookingcount";
import MetricConversionTrivago from "models/metrics/metasearchMetrics/trivago-meta/conversion/MetricConversion";
import MetricRevenuePerclickTrivago from "models/metrics/metasearchMetrics/trivago-meta/conversion/MetricRevenuePerclick";
import MetricRoiTrivago from "models/metrics/metasearchMetrics/trivago-meta/performance/MetricRoi";

// performance
import MetricClicksTrivago from "models/metrics/metasearchMetrics/trivago-meta/performance/MetricClicks";
import MetricCpcTrivago from "models/metrics/metasearchMetrics/trivago-meta/performance/MetricCpc";
import MetricCsrTrivago from "models/metrics/metasearchMetrics/trivago-meta/performance/MetricCsr";
import MetricCtrTrivago from "models/metrics/metasearchMetrics/trivago-meta/performance/MetricCtr";
import MetricGeneratedTrivago from "models/metrics/metasearchMetrics/trivago-meta/performance/MetricGenerated";
import MetricLoseTrivago from "models/metrics/metasearchMetrics/trivago-meta/performance/MetricLose";
import MetricMeetTrivago from "models/metrics/metasearchMetrics/trivago-meta/performance/MetricMeet";
import MetricOutbidRatioTrivago from "models/metrics/metasearchMetrics/trivago-meta/performance/MetricOutbidRatio";
import MetricSpentTrivago from "models/metrics/metasearchMetrics/trivago-meta/performance/MetricSpent";

// visibility
import MetricBeatTrivago from "models/metrics/metasearchMetrics/trivago-meta/visibility/MetricBeat";
import MetricEligImprTrivago from "models/metrics/metasearchMetrics/trivago-meta/visibility/MetricEligImpr";
import MetricImprTrivago from "models/metrics/metasearchMetrics/trivago-meta/visibility/MetricImpr";
import MetricImprShareTrivago from "models/metrics/metasearchMetrics/trivago-meta/visibility/MetricImprShare";
import MetricTopPosShareTrivago from "models/metrics/metasearchMetrics/trivago-meta/visibility/MetricTopPosShare";
import MetricBeatVsChamp from "./visibility/MetricBeatVsChamp";
import MetricMeetVsChamp from "./visibility/MetricMeetVsChamp";
import MetricOpportunity from "./visibility/MetricOpportunityCount";
import MetricLoseVsChamp from "./visibility/MetricLoseVsChamp";

const trivagoMetaMetrics = [
    // connectivity
    new MetricUnavailabilityTrivago(),
    // conversion
    new MetricBookingcountTrivago(),
    new MetricConversionTrivago(),
    new MetricRevenuePerclickTrivago(),
    new MetricRoiTrivago(),
    // performance
    new MetricClicksTrivago(),
    new MetricCpcTrivago(),
    new MetricCsrTrivago(),
    new MetricCtrTrivago(),
    new MetricGeneratedTrivago(),
    new MetricLoseTrivago(),
    new MetricMeetTrivago(),
    new MetricOutbidRatioTrivago(),
    new MetricSpentTrivago(),
    new MetricBeatVsChamp(),
    new MetricMeetVsChamp(),
    new MetricLoseVsChamp(),
    // visibility
    new MetricBeatTrivago(),
    new MetricEligImprTrivago(),
    new MetricImprTrivago(),
    new MetricImprShareTrivago(),
    new MetricOpportunity(),
    new MetricTopPosShareTrivago(),
];

export function findMetricById(metricId) {
    return trivagoMetaMetrics.find((metricClass) => metricClass.field === metricId);
}

export default trivagoMetaMetrics;
